import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {ResponseApi} from "../../Model/ResponseApi.js";
import {ITemplateModel} from "../../Model/Template/ITemplateModel.js";
import {TypeProcessEnum} from "../../Variables/TypeProcessEnum.js";
import {TypeContentEnum} from "../../Variables/TypeContentEnum.js";
import {NotificationHelper} from "../../Helper/NotificationHelper";

export class TemplateTranslate {
    /**
     * Demande au serveur de traduire le pivot vers toutes les langues déclarées
     * du groupe (Claude) et de les enregistrer. Renvoie le groupe i18n rechargé
     * (pivot + traductions), ou null en cas d'erreur.
     */
    public static Translate = async (templateId: string): Promise<Array<ITemplateModel> | null> => {
        return JsonFetchJson.Post<ResponseApi<Array<ITemplateModel>>>("/template/translate", {TemplateId: templateId})
            .then(response => {
                if (response.Errors && response.Errors.length > 0) {
                    response.Errors.forEach(x => NotificationHelper.Instance.error(x.Message));
                    return null;
                }

                response.Data.forEach(x => {
                    x.TypeContentLibelle = TypeContentEnum.Instance.GetLibelle(x.TypeContent);
                    x.TypeProcessLibelle = TypeProcessEnum.Instance.GetLibelle(x.TypeProcess);
                });
                return response.Data;
            });
    }
}
